import { all } from "redux-saga/effects";
import loginSaga from "./login/saga";
import packageSaga from "./package/saga";
import studentSaga from "./students/saga";
import staffSaga from "./staffs/saga";
import bookingActivity from './bookingActivity/saga';
import invoiceSaga from "./invoice/saga";
import calendarSaga from "./calendar/saga";
import parentSaga from "./parent/saga";
import settingSaga from "./setting/saga";
import notificationSaga from "./notification/saga";
import dashboardSaga from "./dashboard/saga";
import multicenterSaga from './multicenter/saga';
import accountSaga from "./accounts/saga";
import userSaga from "./users/saga";
import reportsSaga from './reports/saga';
import accountLoginSaga from "./accountLogin/saga";
import accountPackageSaga from "./accountPackage/saga";
import paymentSaga from "./payment/saga";
import attendanceSaga from './attendance/saga';
import activitySaga from "./activity/saga";
import rolesSaga from "./roles/saga";
import godModeSaga from "./godMode/saga";

export default function* rootSaga(getState) {
	yield all([
		loginSaga(),
		packageSaga(),
		bookingActivity(),
		studentSaga(),
		staffSaga(),
		invoiceSaga(),
		calendarSaga(),
		parentSaga(),
		settingSaga(),
		notificationSaga(),
		dashboardSaga(),
		accountSaga(),
		userSaga(),
		multicenterSaga(),
		reportsSaga(),
		accountLoginSaga(),
		accountPackageSaga(),
		paymentSaga(),
		attendanceSaga(),
		activitySaga(),
		rolesSaga(),
		godModeSaga()
	]);
}